import { datadogRum } from '@datadog/browser-rum';

/**
 * Set user context for Datadog RUM
 * @param {Object} userInfo - User information object
 */
export const setUserContext = (userInfo) => {
  try {
    // Extract role names from roles array
    const roleNames = Array.isArray(userInfo.roles)
      ? userInfo.roles.map((role) => role.name || role)
      : [];

    datadogRum.setUser({
      id: userInfo.id,
      roles: roleNames,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to set user context:', error);
  }
};

/**
 * Clear user context from Datadog RUM
 */
export const clearUserContext = () => {
  try {
    datadogRum.clearUser();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to clear user context:', error);
  }
};
